import { FluentProvider } from '@fluentui/react-components'
import { useEffect, useRef, useState } from 'react'
import { SPLASH_DURATION_MS } from './components/SplashScreen/SplashScreen'
import { useAuth, useAuthenticatedApi, useTheme } from './hooks'
import { useGetModels } from './hooks/useGetModels'
import { Login } from './pages'

interface ProtectedRouteProps {
  children: React.ReactNode
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { theme } = useTheme()
  const { isAuthenticated } = useAuth()
  const [showSplash, setShowSplash] = useState(true)

  // Set up auth interceptors and prefetch models as soon as auth is ready,
  // so both are done by the time the splash screen ends.
  useAuthenticatedApi()
  useGetModels(isAuthenticated)
  const splashTimeout = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    splashTimeout.current = setTimeout(() => setShowSplash(false), SPLASH_DURATION_MS)
    return () => {
      if (splashTimeout.current) clearTimeout(splashTimeout.current)
    }
  }, [])

  // Render app only after both: auth complete AND splash duration elapsed
  if (isAuthenticated && !showSplash) {
    return <FluentProvider theme={theme}>{children}</FluentProvider>
  }

  return (
    <FluentProvider theme={theme}>
      <Login showSplash={showSplash} />
    </FluentProvider>
  )
}

export { ProtectedRoute }
